import { render, staticRenderFns } from "./OrbitAddOwnerModal.vue?vue&type=template&id=6976b3f5"
import script from "./OrbitAddOwnerModal.vue?vue&type=script&lang=ts"
export * from "./OrbitAddOwnerModal.vue?vue&type=script&lang=ts"
import style0 from "./OrbitAddOwnerModal.vue?vue&type=style&index=0&id=6976b3f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports